var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacbook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "devicon:facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.1659 1.20703H2.84344C1.94183 1.20703 1.21094 1.93793 1.21094 2.83953V29.162C1.21094 30.0636 1.94183 30.7945 2.84344 30.7945H29.1659C30.0675 30.7945 30.7984 30.0636 30.7984 29.162V2.83953C30.7984 1.93793 30.0675 1.20703 29.1659 1.20703Z",
    fill: "#3D5A98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.6213 30.7937V19.3362H25.4663L26.0413 14.8712H21.6213V12.0212C21.6213 10.7287 21.9813 9.84623 23.8338 9.84623H26.1988V5.84623C25.0535 5.72687 23.9027 5.67012 22.7513 5.67623C19.3463 5.67623 17.0013 7.75123 17.0013 11.5787V14.8712H13.1562V19.3362H17.0013V30.7937H21.6213Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacbook);
export default __webpack_public_path__ + "static/media/facbook.521f4da2efa5b6ca9db75a0c4eb7c878.svg";
export { ForwardRef as ReactComponent };